export default `float de(vec3 p){
    vec2 p0 = p.xy; 
    vec2 md = min(p.xy, vec2(0.0));

    return length(max(p0, vec2(0.0))) + max(max(md.x, md.y), md.z);
  }`